export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
export class BotAPIClient {
    constructor(version, baseUrl = API_BASE_URL) {
        this.version = version;
        this.baseUrl = baseUrl;
    }
    async getHealth() {
        const response = await fetch(`${this.baseUrl}/health`);
        if (!response.ok) {
            throw new Error(`Health check failed: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getState() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/state`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch state: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getExperiments() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/experiments`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch experiments: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getPositions() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/positions`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch positions: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getTrades() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/trades`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch trades: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getWhales() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/whales`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch whales: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getWhaleDetail(address) {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/whales/${address}/trades`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch whale detail: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getDiscoveryQueue() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/whales/discovery`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch discovery queue: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getBlacklist() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/whales/blacklist`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch blacklist: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async toggleBlacklist(address, action, reason) {
        const body = { action };
        if (reason)
            body['reason'] = reason;
        const response = await fetch(`${this.baseUrl}/api/${this.version}/whales/${address}/blacklist`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new Error(`Failed to toggle blacklist: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async getSkipSummary() {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/skips/summary`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch skip summary: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async updateExperimentConfig(expId, config) {
        const response = await fetch(`${this.baseUrl}/api/${this.version}/experiments/${expId}/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config),
        });
        if (!response.ok) {
            throw new Error(`Failed to update experiment config: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    setVersion(version) {
        this.version = version;
    }
    getVersion() {
        return this.version;
    }
    async getSnapshots(dateFilter, limit = 100) {
        const params = new URLSearchParams();
        if (dateFilter)
            params.set('date', dateFilter);
        params.set('limit', limit.toString());
        const response = await fetch(`${this.baseUrl}/api/${this.version}/snapshots?${params}`);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to fetch snapshots: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
    async compareSnapshot(timestamp, experimentId) {
        const params = new URLSearchParams();
        if (experimentId)
            params.set('experiment_id', experimentId);
        const url = `${this.baseUrl}/api/${this.version}/snapshots/${timestamp}/compare?${params}`;
        const response = await fetch(url);
        if (!response.ok && response.status !== 404) {
            throw new Error(`Failed to compare snapshot: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    }
}
//# sourceMappingURL=client.js.map